module.exports = __webpack_public_path__ + "img/kh30.e2fc1b4f.png";